module.exports = __webpack_public_path__ + "7206b9d61bcbac5c17cd44c134d07dd9.pdf";